import LocalTranslations from "../../en-GB/en-GB";
import {flattenObject} from "~/i18n/src/helpers/flatten";
export default defineI18nLocale(async (locale:string) => {
    return $fetch(`/api/translations/en-GB`).then((response) => {
        let AllTranslations = {...flattenObject(LocalTranslations), ...response};

        if (get('lang_debug')) {
            return {};
        }

        return AllTranslations;
    });
})

function get(name:string){
    let result = (new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location?.search);
    if(result) {
        return decodeURIComponent(result[1]);
    }
}
